var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaneIconBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "m41.5154 45.2719-7.3251-8.3213c-.3567-.4053-.1903-1.0426.3188-1.2222l10.4599-3.6847c.4608-.1622.9531.1449 1.01.63l.9169 7.8409c.2292 1.9593-.8245 3.8448-2.6134 4.6763l-.981.456a1.524 1.524 0 0 1-1.7861-.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M60 19.713C60 30.3067 9.9633 42 6.1745 42c-2.1242 0-4.5343-.4997-4.5343-2.4986 0-.6678.7552-1.6329 2.0804-2.7966l-.0015.0008-3.5123-6.3697c-.4756-.8623-.0986-1.9548.8014-2.3227l.6037-.2466a3.938 3.938 0 0 1 3.3667.1821l6.3764 3.4455c2.4826-1.5029 5.2989-3.0766 8.2672-4.6258l-12.426-8.2283c-.983-.6509-.9725-2.1234.0198-2.7595l1.0164-.6518c1.6918-1.0848 3.7485-1.4052 5.6802-.8852l20.6716 5.5651c6.4454-2.611 12.2726-4.3931 15.7219-4.3931.9211 0 1.8437.0249 2.7341.0898l-6.2427 2.8763-.1494 2.1432 9.6362-4.5212C58.5943 16.566 60 17.6154 60 19.713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD3FF",
    d: "M59 19.3175c0 9.8604-47.5348 20.7443-51.1342 20.7443-2.018 0-4.3076-.4652-4.3076-2.3256 0-.6216.7174-1.52 1.9764-2.6031l-.0014.0007-3.3368-5.9287c-.4518-.8027-.0936-1.8195.7614-2.162l.5735-.2295a3.81 3.81 0 0 1 3.1984.1695l6.0576 3.207c2.3585-1.3989 5.0339-2.8636 7.8538-4.3056L8.8365 18.2258c-.934-.6058-.924-1.9764.0187-2.5684l.9656-.6067a6.856 6.856 0 0 1 5.3962-.8239l19.6379 5.1798c6.1232-2.4303 11.6591-4.089 14.9359-4.089.8751 0 1.7515.0232 2.5973.0836l-5.9305 2.6772-.1419 1.9948 9.1544-4.2082C57.6646 16.3883 59 17.3651 59 19.3175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#89CAFF",
    d: "m41.9346 45.0717-7.3251-8.3213c-.3567-.4053-.1904-1.0426.3187-1.2222l10.46-3.6847c.4608-.1622.9531.1449 1.0099.63l.917 7.8409c.2292 1.9593-.8246 3.8448-2.6135 4.6763l-.981.456a1.524 1.524 0 0 1-1.786-.375"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "svg_0a",
    width: 57,
    height: 27,
    x: 2,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD3FF",
    d: "M59 19.3175c0 9.8604-47.5348 20.7443-51.1342 20.7443-2.018 0-4.3076-.4652-4.3076-2.3256 0-.6216.7174-1.52 1.9764-2.6031l-.0014.0007-3.3368-5.9287c-.4518-.8027-.0936-1.8195.7614-2.162l.5735-.2295a3.81 3.81 0 0 1 3.1984.1695l6.0576 3.207c2.3585-1.3989 5.0339-2.8636 7.8538-4.3056L8.8365 18.2258c-.934-.6058-.924-1.9764.0187-2.5684l.9656-.6067a6.856 6.856 0 0 1 5.3962-.8239l19.6379 5.1798c6.1232-2.4303 11.6591-4.089 14.9359-4.089.8751 0 1.7515.0232 2.5973.0836l-5.9305 2.6772-.1419 1.9948 9.1544-4.2082C57.6646 16.3883 59 17.3651 59 19.3175"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89CAFF",
    d: "m3.4979 54.8917-8.1854-19.1898s25.3991 2.8241 46.838-6.8338C59.5696 21.0212 63.384 10.6916 63.384 10.6916l7.5806 16.7641z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaneIconBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plane-icon-big.986c1f9584c909185d26dcfa0c8cf215.svg";